// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import OScontent from './PageComponent/OScontent'

function OperatingSystems() {

  useMeta({
    title: 'Operating Systems | Callistus Blinds',
    description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
    canonical: 'https://callistusblinds.com/operating-systems/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Operating Systems | Callistus Blinds',
      description:
        '1st Time for Roman Blinds – Unique Fabric Conversion',
      url: 'https://callistusblinds.com/operating-systems/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <NotificationBar />
      <OScontent />
      <Footer />
    </div>
  );
}

export default OperatingSystems;
